// Libs
import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'

// CSS
import './styles.scss'

// Actions
import { changeVisible, changeTitle, changeText, fetchMediate, newMediate } from './actions'

class Mediator extends Component {
  state = {
    intervalId: ''
  }

  UNSAFE_componentWillMount() {
    const { spCase: { id }, title, text, changeVisible, fetchMediate, newMediate } = this.props

    newMediate(id, title, text)

    const intervalId = setInterval(() => {
      const { title, text } = this.props

      newMediate(id, title, text)
    }, 10000)

    this.setState({ intervalId })
  }

  componentWillUnmount() {
    const { changeVisible, changeTitle, changeText } = this.props
    const { intervalId } = this.state

    clearInterval(intervalId)

    changeVisible(false)
    changeTitle('')
    changeText('')
  }

  render() {
    const { visible, title, text } = this.props

    return (
      <div className={visible ? "mediator mediator--visible" : "mediator"}>
        <div className="mediator__container">
          <p>{title}</p>
          <p>{text}</p>
        </div>
        <div className="mediator__balls">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    )
  }
}

Mediator = connect(state => {
  return {
    visible: state.mediator.visible,
    title: state.mediator.title,
    text: state.mediator.text,
    spCase: state.spCasePage.spCase
  }
}, { changeVisible, changeTitle, changeText, fetchMediate, newMediate })(Mediator)

export default Mediator
